// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a074b9cf","239":"4bb2f6fe","453":"f091ad37","732":"530ff551"}[chunkId] + ".chunk.js";
};